import React, { lazy, Suspense } from 'react';
import SimplePulse from './animations/SimplePulse';
import MorphingGradientOrb from './animations/MorphingGradientOrb';

// Lazy-load canvas-heavy animations for code splitting
const SiriNoiseOrb = lazy(() => import('./animations/SiriNoiseOrb'));
const ParticleCloud = lazy(() => import('./animations/ParticleCloud'));
const WaveformRing = lazy(() => import('./animations/WaveformRing'));

const ANIMATION_MAP = {
    'simple-pulse': SimplePulse,
    'morphing-gradient': MorphingGradientOrb,
    'siri-noise': SiriNoiseOrb,
    'particle-cloud': ParticleCloud,
    'waveform-ring': WaveformRing,
};

export default function AIOrb({ style = 'morphing-gradient', amplitude = 0, isSpeaking = false, isThinking = false, size = 64 }) {
    const Component = ANIMATION_MAP[style] || MorphingGradientOrb;
    const isLazy = ['siri-noise', 'particle-cloud', 'waveform-ring'].includes(style);

    const orb = <Component amplitude={amplitude} isSpeaking={isSpeaking} isThinking={isThinking} size={size} />;

    if (isLazy) {
        return (
            <Suspense fallback={<SimplePulse amplitude={amplitude} isSpeaking={isSpeaking} isThinking={isThinking} size={size} />}>
                {orb}
            </Suspense>
        );
    }

    return orb;
}
